import { apiFetch } from '@/shared/lib/apiClient';
import type { CodeStatusResponseDto } from '@/shared/lib/apiTypes';

/**
 * 저장된 유저 코드의 누적 진행 상태를 조회한다.
 *
 * Swagger: `GET /api/code/status/{userCode}` — 누적 코드 수와 (임계값 도달 시) 다운로드 URL.
 * 페이지 부팅 시 localStorage 에 보관 중인 `userCode` 가 여전히 유효한지 검증하면서
 * 클라이언트 카운트를 서버 권위 값으로 동기화하는 데 사용된다.
 *
 * @param userCode - 조회할 6자리 유저 코드.
 * @returns 누적 카운트와 보상 다운로드 URL.
 * @throws ApiError(404) 서버에 존재하지 않는 코드인 경우 (이 경우 호출 측은 localStorage 정리 후 재발급).
 */
export async function getCodeStatus(
  userCode: string,
): Promise<CodeStatusResponseDto> {
  return apiFetch<CodeStatusResponseDto>(
    `/api/code/status/${encodeURIComponent(userCode)}`,
    { method: 'GET' },
  );
}
